/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Spaces_BodyInputs */



/**
* | output |
* | --- |
* | "Connected knowledge: folders, SharePoint, drives and tools the AI can read from." |
*
* @param {Onboarding_Tour_Spaces_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_spaces_body = /** @type {((inputs?: Onboarding_Tour_Spaces_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Spaces_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Angebundenes Wissen: Ordner, SharePoint, Laufwerke und Tools, aus denen die KI lesen kann.")
	return /** @type {LocalizedString} */ ("Connected knowledge: folders, SharePoint, drives and tools the AI can read from.")
});